import {IStore} from './IStore';

// TODO: because of page reload this is I think broken
// value of language comes from sessionStorage, and should come from redux store
// this initialization is broken - to review in future

export const initialState: IStore = {
    applicationSettings: {},
    configurations: {},
    languages: [],
    translations: {}
};
